// Force units data for conversion routes
// Base unit: newton (N)

export const forceUnits = [
  { id: 'newton', name: 'Newton', symbol: 'N', plural: 'Newtons', factor: 1 },
  { id: 'kilonewton', name: 'Kilonewton', symbol: 'kN', plural: 'Kilonewtons', factor: 1000 },
  { id: 'meganewton', name: 'Meganewton', symbol: 'MN', plural: 'Meganewtons', factor: 1000000 },
  { id: 'millinewton', name: 'Millinewton', symbol: 'mN', plural: 'Millinewtons', factor: 0.001 },
  { id: 'dyne', name: 'Dyne', symbol: 'dyn', plural: 'Dynes', factor: 0.00001 },
  { id: 'kilogram-force', name: 'Kilogram-force', symbol: 'kgf', plural: 'Kilogram-force', factor: 9.80665 },
  { id: 'gram-force', name: 'Gram-force', symbol: 'gf', plural: 'Gram-force', factor: 0.00980665 },
  { id: 'pound-force', name: 'Pound-force', symbol: 'lbf', plural: 'Pound-force', factor: 4.448222 },
  { id: 'ounce-force', name: 'Ounce-force', symbol: 'ozf', plural: 'Ounce-force', factor: 0.2780139 },
  { id: 'poundal', name: 'Poundal', symbol: 'pdl', plural: 'Poundals', factor: 0.138255 },
  { id: 'kip', name: 'Kip', symbol: 'kip', plural: 'Kips', factor: 4448.222 },
];

// Popular conversions matching common usage
export const popularForceConversions = [
  { from: 'newton', to: 'pound-force' },
  { from: 'pound-force', to: 'newton' },
  { from: 'newton', to: 'kilogram-force' },
  { from: 'kilogram-force', to: 'newton' },
  { from: 'kilonewton', to: 'newton' },
  { from: 'newton', to: 'kilonewton' },
  { from: 'kilonewton', to: 'pound-force' },
  { from: 'pound-force', to: 'kilonewton' },
  { from: 'newton', to: 'dyne' },
  { from: 'dyne', to: 'newton' },
  { from: 'kilogram-force', to: 'pound-force' },
  { from: 'pound-force', to: 'kilogram-force' },
  { from: 'kilonewton', to: 'kilogram-force' },
  { from: 'kilogram-force', to: 'kilonewton' },
  { from: 'kip', to: 'kilonewton' },
  { from: 'kilonewton', to: 'kip' },
];

export const getUnitById = (id) => forceUnits.find(unit => unit.id === id);

export const convertForce = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const newtons = value * fromUnit.factor;
  return newtons / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => `Convert ${fromUnit.plural} to ${toUnit.plural}`;

export const generateSEODescription = (fromUnit, toUnit) => {
  const result = convertForce(1, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000 ? result.toExponential(4) : result.toPrecision(6).replace(/\.?0+$/, '');
  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online force unit converter.`;
};
